import { render } from "./Detail.vue?vue&type=template&id=2ed9711a"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"
script.render = render

export default script